// Approximate geographic centre of each country we ship to, as [lat, lon].
//
// The coverage map plots one marker per country, so a centroid is all it needs
// and a full polygon set would be megabytes for no extra meaning. Accuracy is
// "the marker sits in the right country", not survey grade. Large or scattered
// countries are placed at their populated centre rather than their geometric
// one, so France sits near Bourges rather than in the Atlantic via its overseas
// territories, and the US near Kansas rather than in the Pacific via Hawaii.
//
// ZZ is the Rest-of-World pseudo-country and deliberately has no position.
export const COUNTRY_CENTROIDS = {
  AD: [42.55, 1.60],    AE: [23.42, 53.85],   AL: [41.15, 20.17],   AM: [40.07, 45.04],
  AR: [-38.42, -63.62], AT: [47.52, 14.55],   AU: [-25.27, 133.78], BA: [43.92, 17.68],
  BE: [50.50, 4.47],    BG: [42.73, 25.49],   BH: [26.07, 50.56],   BR: [-14.24, -51.93],
  BY: [53.71, 27.95],   CA: [56.13, -106.35], CH: [46.82, 8.23],    CL: [-35.68, -71.54],
  CN: [35.86, 104.20],  CO: [4.57, -74.30],   CY: [35.13, 33.43],   CZ: [49.82, 15.47],
  DE: [51.17, 10.45],   DK: [56.26, 9.50],    EE: [58.60, 25.01],   EG: [26.82, 30.80],
  ES: [40.46, -3.75],   FI: [61.92, 25.75],   FR: [46.60, 1.89],    GB: [54.00, -2.00],
  GE: [42.32, 43.36],   GI: [36.14, -5.35],   GR: [39.07, 21.82],   HK: [22.32, 114.17],
  HR: [45.10, 15.20],   HU: [47.16, 19.50],   IE: [53.41, -8.24],   IL: [31.05, 34.85],
  IN: [20.59, 78.96],   IS: [64.96, -19.02],  IT: [41.87, 12.57],   JE: [49.21, -2.13],
  JP: [36.20, 138.25],  KR: [35.91, 127.77],  KW: [29.31, 47.48],   KZ: [48.02, 66.92],
  LB: [33.85, 35.86],   LI: [47.17, 9.56],    LT: [55.17, 23.88],   LU: [49.82, 6.13],
  LV: [56.88, 24.60],   MC: [43.75, 7.41],    ME: [42.71, 19.37],   MK: [41.61, 21.75],
  MT: [35.94, 14.38],   MX: [23.63, -102.55], MY: [4.21, 101.98],   NL: [52.13, 5.29],
  NO: [60.47, 8.47],    NZ: [-40.90, 174.89], PE: [-9.19, -75.02],  PH: [12.88, 121.77],
  PL: [51.92, 19.15],   PT: [39.40, -8.22],   QA: [25.35, 51.18],   RO: [45.94, 24.97],
  RS: [44.02, 21.01],   RU: [55.75, 50.00],   SA: [23.89, 45.08],   SC: [-4.68, 55.49],
  SE: [60.13, 18.64],   SG: [1.35, 103.82],   SI: [46.15, 14.99],   SK: [48.67, 19.70],
  SM: [43.94, 12.46],   SR: [3.92, -56.03],   TH: [15.87, 100.99],  TR: [38.96, 35.24],
  TW: [23.70, 120.96],  UA: [48.38, 31.17],   US: [39.50, -98.35],  VA: [41.90, 12.45],
  XK: [42.60, 20.90],   ZA: [-30.56, 22.94],
}

// Latitude/longitude to a point on a unit sphere of the given radius.
// Three.js has Y up, so latitude drives Y and longitude sweeps the XZ plane.
export function latLonToVec3(lat, lon, radius) {
  const phi = (90 - lat) * (Math.PI / 180)
  const theta = (lon + 180) * (Math.PI / 180)
  return [
    -radius * Math.sin(phi) * Math.cos(theta),
    radius * Math.cos(phi),
    radius * Math.sin(phi) * Math.sin(theta),
  ]
}
